import { t } from "i18next";

import { EReputationMatchResult, PersonProfile } from "src/core/types/entity";

type PhotosSectionProps = {
  selectedMatch: EReputationMatchResult;
};

function isPersonProfileWithImages(
  detail: EReputationMatchResult["detail"]
): detail is PersonProfile {
  return detail != null && "images" in detail && Array.isArray(detail.images);
}

export const PhotosSection = ({ selectedMatch }: PhotosSectionProps) => {
  const detail = selectedMatch?.detail;
  if (!isPersonProfileWithImages(detail) || !detail.images.length) {
    return (
      <div className="ml-2 font-light">{t("modal.entityDetails.sections.photos.no_photos")}</div>
    );
  }

  return (
    <div className="px-10">
      <div className="grid grid-cols-4 gap-4 mt-2">
        {detail.images.map((url: string, index: number) => (
          <a
            key={index}
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="block w-full aspect-square overflow-hidden rounded-lg border border-border"
          >
            <img src={url} alt={`${index + 1}`} className="w-full h-full object-cover" />
          </a>
        ))}
      </div>
    </div>
  );
};
